<template>
    <el-dialog
        class="attendance-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        width="440px"
        center
    >
        <div class="container">
            <div class="header">
                <div class="wrap">
                    <div class="left-btn el-icon-arrow-left" @click="clickLastMonth"></div>
                    <div class="year-month">{{ year }}年{{ monthFormat() }}月</div>
                    <div class="right-btn el-icon-arrow-right" @click="clickNextMonth"></div>
                </div>
            </div>

            <div v-loading="loading" class="items">
                <template v-for="(item, index) of pageData">
                    <div :key="index" class="item">
                        <div class="title" @click="handleClick(item)">
                            <i v-if="!item.isActive" class="icon el-icon-caret-right "></i>
                            <i v-else class="icon el-icon-caret-bottom" style=" color: #54a183;"></i>
                            <span class="label">{{ item.title }}</span>
                            <span class="value">{{ item.count }}</span>
                        </div>
                        <div v-if="item.isActive" class="list">
                            <template v-for="(ele, index1) of item.list">
                                <div :key="index1" class="day">
                                    <div>{{ ele.title }}</div>
                                    <div>{{ ele.subTitle }}</div>
                                </div>
                            </template>
                            <div v-if="item.list.length === 0" class="emply">
                                <div>
                                    <span>无记录</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getCheckData } from "@/api";
import dayjs from "dayjs";
import { getLocalStorage } from "@/libs/mUtils";
// 确定发布弹框
export default {
    name: "AttendanceDialog",
    components: {},
    props: {},
    data() {
        return {
            loading: false,
            dialogVisible: false,
            year: "", // 年
            month: "", // 月
            pageData: [], // 展示数据
        };
    },
    methods: {
        show() {
            this.dialogVisible = true;
            let date = new Date();
            this.year = date.getFullYear();
            this.month = date.getMonth() + 1;
            this.loadData();
        },
        loadData() {
            //  调用接口
            this.checkin();
            // this.pageData = [];
            // this.pageData = this.demoData();
            // this.pageData.forEach((ele) => {
            //     ele.isActive = false; // 控制是否展开
            // });
        },

        // 通过账户名称获取考勤异常统计信息
        async checkin() {
            this.loading = true;
            try {
                const auth_user = getLocalStorage("user");
                const username = auth_user.userData.username;
                const { code, body, message } = await getCheckData({
                    oaAccount: username,
                    checkDate: this.dateFormat(),
                });
                if (code === "0000") {
                    this.handleAbnormalData(body);
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
            this.loading = false;
        },

        // 处理异常考勤
        handleAbnormalData(data) {
            const datarest = data.rest || [];
            const rest = {
                key: "rest",
                title: "休假",
                count: datarest.reduce((total, current) => current["durationDays"] + total, 0) + "天",
                className: datarest.length ? "default" : "",
                list: datarest.map((item = {}) => {
                    item["title"] =
                        item["workDate"] +
                        "（星期" +
                        this.handleWeek(item["workDate"]) +
                        "）" +
                        item["leaveIntervalName"];
                    item["subTitle"] = item["leaveTypeName"];
                    return item;
                }),
            };
            const dataLate = data.late || [];
            const late = {
                key: "late",
                title: "迟到",
                count:
                    dataLate.length +
                    "次，共" +
                    dataLate.reduce((total, current) => current["lateMinutes"] + total, 0) +
                    "分钟",
                className: dataLate.length ? "warning" : "",
                list: dataLate.map((item = {}) => {
                    item["title"] =
                        item["workDate"] +
                        "（星期" +
                        this.handleWeek(item["workDate"]) +
                        "）" +
                        dayjs(item["actualStartDt"]).format("HH:mm");
                    item["subTitle"] = "上班迟到" + item["lateMinutes"] + "分钟";
                    return item;
                }),
            };
            const dataEarly = data.early || [];
            const early = {
                key: "early",
                title: "早退",
                count: dataEarly.length + "次",
                className: dataEarly.length ? "warning" : "",
                list: dataEarly.map((item = {}) => {
                    item["title"] =
                        item["workDate"] +
                        "（星期" +
                        this.handleWeek(item["workDate"]) +
                        "）" +
                        dayjs(item["actualEndDt"]).format("HH:mm");
                    item["subTitle"] = "上班早退" + item["earlyMinutes"] + "分钟";
                    return item;
                }),
            };
            const dateAbsent = data.absent || [];
            const absent = {
                key: "absent",
                title: "旷工",
                count:
                    dateAbsent.reduce((total, current = {}) => {
                        return (total += current["absentDays"] || 0);
                    }, 0) + "天",
                className: dateAbsent.length ? "warning" : "",
                list: dateAbsent.map((item = {}) => {
                    item["title"] =
                        item["workDate"] +
                        "（星期" +
                        this.handleWeek(item["workDate"]) +
                        "）" +
                        this.getAbsentType(item);
                    item["subTitle"] = "旷工" + item["absentDays"] + "天";
                    return item;
                }),
            };
            const dataTravel = data.onBusinesses || [];
            const travel = {
                key: "travel",
                title: "出差",
                count: dataTravel.length + "天",
                className: dataTravel.length ? "default" : "",
                list: dataTravel.map((item = {}) => {
                    item["title"] = item["errDate"] + "（星期" + this.handleWeek(item["errDate"]) + "）";
                    item["subTitle"] = "出差" + 1 + "天";
                    return item;
                }),
            };

            //  调用接口
            this.pageData = [rest, late, absent, early, travel];
            this.pageData.forEach((ele) => {
                ele.isActive = false; // 控制是否展开
            });
        },
        handleWeek(date = "") {
            if (!date || date === "") {
                return "";
            }
            const week = new Date(date).getDay();
            switch (week) {
                case 0:
                    return "日";
                case 1:
                    return "一";
                case 2:
                    return "二";
                case 3:
                    return "三";
                case 4:
                    return "四";
                case 5:
                    return "五";
                case 6:
                    return "六";
            }
        },
        // 获取旷工类型
        getAbsentType(item = {}) {
            // 根据打卡时间判断
            if (item["startCardNbr"]) {
                return "下午旷工";
            } else if (item["endCardNbr"]) {
                return "上午旷工";
            }
            return "";
        },
        demoData() {
            let obj1 = {
                id: 1,
                title: "迟到",
                value: 2,
                days: [
                    { id: 11, date: "2021-09-12(礼拜天)", value: "迟到5分钟" },
                    { id: 12, date: "2021-09-13(礼拜天)", value: "迟到10分钟" },
                ],
            };
            let obj2 = {
                id: 2,
                title: "请假",
                value: 2,
                days: [
                    { id: 21, date: "2021-09-14(礼拜天)", value: "调休1天" },
                    { id: 22, date: "2021-09-15(礼拜天)", value: "事假1天" },
                ],
            };
            let obj3 = {
                id: 3,
                title: "早退",
                value: 1,
                days: [{ id: 31, date: "2021-09-16(礼拜天)", value: "早退10分钟" }],
            };
            let obj4 = {
                id: 4,
                title: "旷工",
                value: 1,
                days: [{ id: 31, date: "2021-09-16(礼拜天)", value: "早退10分钟" }],
            };
            let obj5 = {
                id: 5,
                title: "出差",
                value: 1,
                days: [],
            };
            return [obj1, obj2, obj3, obj4, obj5];
        },

        // 上个月
        clickLastMonth() {
            this.month = this.month - 1;
            if (this.month < 1) {
                this.month = 12;
                this.year = this.year - 1;
            }
            this.loadData();
        },
        // 下个月
        clickNextMonth() {
            this.month = this.month + 1;
            if (this.month > 12) {
                this.month = 1;
                this.year = this.year + 1;
            }
            this.loadData();
        },
        // 展开 收起
        handleClick(item) {
            item.isActive = !item.isActive;
            this.$forceUpdate();
        },
        // 月
        monthFormat() {
            return this.month > 9 ? this.month : "0" + this.month;
        },
        // 日期
        dateFormat() {
            return this.year + "-" + this.monthFormat();
        },
        handleClose() {
            this.dialogVisible = false;
        },
    },
};
</script>

<style scoped lang="scss">
.attendance-dialog {
    /deep/ .el-dialog__header {
        border-radius: 8px 8px 0 0;
    }
    /deep/ .el-dialog {
        border-radius: 8px;
    }
    .container {
        padding-bottom: 30px;
        .header {
            height: 50px;
            // border: 1px solid #ccc;
            display: flex;
            justify-content: center;
            .wrap {
                display: flex;
                align-items: center;
                // margin-bottom: 40px;
                padding-top: 20px;
                .year-month {
                    margin-left: 44px;
                    margin-right: 44px;
                    height: 33px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 33px;
                }

                .left-btn {
                    cursor: pointer;
                    font-size: 24px;
                }

                .right-btn {
                    cursor: pointer;
                    font-size: 24px;
                }
            }
        }
        .items {
            // height: 400px;
            padding: 0 20px;
            padding-top: 20px;
            .item {
                margin-bottom: 10px;
                .title {
                    padding: 10px;
                    position: relative;
                    border: 1px solid #ccc;
                    border-radius: 4px 4px 0 0;
                    cursor: pointer;
                    .value {
                        display: inline-block;
                        position: absolute;
                        right: 10px;
                    }
                    .label {
                        margin-left: 10px;
                    }
                    .value {
                        color: #54a183;
                    }
                }
                .list {
                    border: 1px solid #ccc;
                    border-top: unset;
                    border-radius: 0 0 4px 4px;
                    .day {
                        display: flex;
                        padding: 10px 30px;
                        justify-content: space-between;
                    }
                    .emply {
                        height: 68px;
                        text-align: center;
                        line-height: 68px;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
.attendance-dialog {
    .el-dialog__header {
        height: 0 !important;
        padding: 0;
        margin: 0;
    }
    .el-dialog__body {
        padding: 0;
        margin: 0;
    }
}
</style>
